import logo from "../images/imvi-logo-blue.png"
import "./Navbar.css";

// Navbar that contains the logo
function Navbar() {
    return (
        <>
      <nav className="navbar">
      <div className="nav--logo-container">
        <a href="https://imvilabs.com/sv/">
          <img className="nav--logo" src={logo} alt="Logo" />
        </a>
      </div>
      </nav>
    </>
    );
  }
  
  export default Navbar;